import { render, staticRenderFns } from "./KasdaDetailTable.vue?vue&type=template&id=30b4f3a4&lang=pug"
import script from "./KasdaDetailTable.vue?vue&type=script&lang=js"
export * from "./KasdaDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports